import { createFileRoute } from '@tanstack/react-router'
import EditionPrints from 'Edition/components/sections/Print/EditionPrints'

export const Route = createFileRoute('/work/$workId_/edition/$editionId/printchanges')({
    component: EditionPrints,
})
